// pages/WebsiteLinks/AddBulkWebsiteLinks.js
import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  Alert,
  CircularProgress,
  Divider,
  useTheme,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useWebsiteScrape } from "../../../contexts/WebsiteScrapeContext";

export default function AddBulkWebsiteLinks({
  closeModal,
  refresh,
  handleRefresh,
  chatbotId,
  permission,
}) {
  const theme = useTheme();
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
  const { isProcessing, startBulkWebsiteAdd } = useWebsiteScrape();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "text/plain") {
      setSelectedFile(file);
      setError(null);
    } else {
      setSelectedFile(null);
      setError("Please upload a valid .txt file.");
    }
  };

  const handleProcessFile = () => {
    if (!selectedFile) {
      setError("Please select a file first.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      const links = text
        .replace(/,/g, "\n")
        .split("\n")
        .map((link) => link.trim())
        .filter((link) => link);

      if (links.length === 0) {
        setError("No valid links found in the file.");
        return;
      }

      setError(null);
      closeModal();
      startBulkWebsiteAdd(links, chatbotId);
      handleRefresh();
    };

    reader.readAsText(selectedFile);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        bgcolor: "background.paper",
        color: "text.primary",
        maxWidth: 700,
        mx: "auto",
      }}
    >
      <Typography variant="h5" fontWeight={700} gutterBottom    color="textPrimary">
        Add <strong>Bulk Website Links</strong>
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
        Upload a <strong>.txt</strong> file with comma-separated or line-separated website links.
      </Typography>

      <TextField
        fullWidth
        type="file"
        inputProps={{ accept: ".txt" }}
        onChange={handleFileChange}
        disabled={isProcessing}
        sx={{
          "& input": { color: "text.primary" },
        }}
      />

      {permission.canModify && (
        <Button
          variant="contained"
          startIcon={<UploadFileIcon />}
          onClick={handleProcessFile}
          disabled={isProcessing}
          sx={{ mt: 2 }}
        >
          {isProcessing ? (
            <>
              <CircularProgress size={18} sx={{ mr: 1 }} /> Processing...
            </>
          ) : (
            "Upload and Process Links"
          )}
        </Button>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Paper>
  );
}
